import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import GlobalPopup from "../../component/Popup/GlobalPopup";
import { openGlobalPopup } from "../../redux/action";
import { useIsMobile } from "../../component/Hooks/useIsMobile";
import AddonList from "../../component/Addon/AddonList";
import AddonForm from "../../component/Addon/AddonForm";
import AddonMobileList from "../../component/Addon/AddonMobileList";

function ManageAddonPage() {
  const dispatch = useDispatch();
  const isMobile = useIsMobile();

  const addonGroups = useSelector((state) => state.admin?.addonGroups) || [];
  const editAddonGroup = useSelector((state) => state.admin?.editAddonGroup);
  const addonSaving = useSelector((state) => Boolean(state.admin?.addonSaving));

  useEffect(() => {
    dispatch({ type: "FETCH_ADDON_GROUPS" });
  }, [dispatch]);

  const handleOpenAdd = () => {
    dispatch({ type: "EDIT_ADDON_GROUP", payload: {} });
    dispatch(openGlobalPopup("manage-addon-popup"));
  };

  const handleOpenEdit = (group) => {
    dispatch({ type: "EDIT_ADDON_GROUP", payload: group });
    dispatch(openGlobalPopup("manage-addon-popup"));
  };

  const handleDelete = (addonGroupId) => {
    dispatch({ type: "DELETE_ADDON_GROUP", payload: addonGroupId });
  };

  const handleClosePopup = () => {
    dispatch({ type: "EDIT_ADDON_GROUP", payload: {} });
  };

  return (
    <div className="container">
      <h1>Manage Add On</h1>

      <button className="add-button ui-page-add-button" onClick={handleOpenAdd}>
        Add Add On
      </button>

      <GlobalPopup
        popupKey="manage-addon-popup"
        title={editAddonGroup?.addonGroupId ? "Edit Add-on" : "Add Add-on's"}
        onClose={handleClosePopup}
        disableClose={addonSaving}
        footer={(closePopup) => (
          <>
            <button type="button" className="popup-action-btn secondary" onClick={closePopup} disabled={addonSaving}>Cancel</button>
            <button
              type="submit"
              form="addon-form"
              className="popup-action-btn"
              disabled={addonSaving}
              aria-busy={addonSaving}
            >
              {addonSaving ? (
                <><span className="popup-button-spinner" aria-hidden="true" />Saving...</>
              ) : editAddonGroup?.addonGroupId ? "Save Add-on" : "Add Add-on"}
            </button>
          </>
        )}
      >
        <AddonForm />
      </GlobalPopup>

     <section className="list-section">
  {isMobile ? (
    <AddonMobileList
      addonGroups={addonGroups}
      onEdit={handleOpenEdit}
      onDelete={handleDelete}
    />
  ) : (
    <AddonList
      addonGroups={addonGroups}
      onEdit={handleOpenEdit}
      onDelete={handleDelete}
    />
  )}
</section>
    </div>
  );
}

export default ManageAddonPage;
